/* Additive enhancement: native theme continues handling variants and cart requests. */
(()=>{

  // Delegation survives native variant section replacement. Capture before theme link handlers.
  if(!window.smouzProductReadMoreBound){
    window.smouzProductReadMoreBound=true;
    document.addEventListener('click',event=>{
      const link=event.target.closest?.('[data-smouz-read-more]');
      if(!link||event.button>0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const root=link.closest('.smouz-product-v8');
      const target=root?.querySelector('.smouz-full-description');
      if(!target)return;
      event.preventDefault();event.stopImmediatePropagation();
      const breathingRoom=window.innerWidth>=1000?48:16;
      let offset=breathingRoom;
      document.querySelectorAll('#header-outer,#header,#nav-outer,.shopify-section-header').forEach(header=>{
        const rect=header.getBoundingClientRect(),style=getComputedStyle(header);
        if((style.position==='fixed'||style.position==='sticky')&&rect.height>0&&rect.bottom>0&&rect.top<window.innerHeight/2){
          offset=Math.max(offset,Math.min(rect.height+Math.max(0,rect.top),window.innerHeight/2)+breathingRoom);
        }
      });
      target.focus({preventScroll:true});
      window.scrollTo({top:Math.max(0,window.scrollY+target.getBoundingClientRect().top-offset),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    },true);
  }
  function initialize(root){
    if(root.dataset.smouzInitialized)return;
    root.dataset.smouzInitialized='true';
    // Read exact labelled table cells; never infer a missing specification.
    const normalize=text=>text.replace(/\u00a0/g,' ').replace(/\s+/g,' ').replace(/:$/,'').trim().toLowerCase();
    const facts=new Map();
    root.querySelectorAll('.smouz-description-content table tr').forEach(row=>{
      const cells=Array.from(row.children).filter(cell=>cell.matches('td,th'));
      if(cells.length===2){const key=normalize(cells[0].textContent),value=cells[1].textContent.trim();if(key&&value)facts.set(key,value)}
    });
    root.querySelectorAll('[data-smouz-fact]').forEach(field=>{
      if(field.textContent.trim()!=='Niet opgegeven')return;
      for(const alias of field.dataset.smouzFact.split('|')){
        const value=facts.get(normalize(alias));if(value){field.textContent=value;if(field.hasAttribute('data-smouz-sound')){if(normalize(alias).includes('lw (is)'))field.textContent+=' (ΔLW, IS)';else if(normalize(alias).includes('rws'))field.textContent+=' (RWS)'}break}
      }
    });
    const description=(root.querySelector('.smouz-description-content')?.textContent||'').replace(/\s+/g,' ');
    const patterns={height:/standaardhoogte van\s+(\d+(?:[.,]\d+)?\s*(?:cm|mm))/i,thickness:/dikte van(?: maar liefst)?\s+(\d+(?:[.,]\d+)?\s*(?:cm|mm))/i,certification:/\b(PEFC|FSC)[-\s]gecertificeerd/i};
    root.querySelectorAll('[data-smouz-optional]').forEach(field=>{
      if(field.textContent.trim()==='Niet opgegeven'){
        const pattern=patterns[field.dataset.smouzFromText];const found=pattern&&description.match(pattern);
        if(found)field.textContent=found[1];
      }
      const missing=field.textContent.trim()==='Niet opgegeven';
      field.hidden=missing;if(field.previousElementSibling?.tagName==='DT')field.previousElementSibling.hidden=missing;
    });
    root.querySelectorAll('[data-smouz-facts-fallback]').forEach(fallback=>{
      fallback.hidden=Array.from(fallback.closest('[data-smouz-facts]').querySelectorAll('dd')).some(dd=>!dd.hidden);
    });
    if(root.dataset.smouzCm!=='true')return;
    let pending=false;
    function update(){
      pending=false;
      const input=root.querySelector('.f8pr-buy-button input[name="quantity"]');
      const price=root.querySelector('.f8pr-price[data-smouz-price]');
      const total=root.querySelector('[data-smouz-total]');
      const length=root.querySelector('[data-smouz-length]');
      if(!input||!price||!total||!length)return;
      const n=Number(input.value), cents=Number(price.dataset.smouzPrice);
      const valid=input.value!==''&&Number.isFinite(n)&&n>=Number(input.min||100)&&input.validity.valid;
      const amount=valid?new Intl.NumberFormat(document.documentElement.lang||'nl-NL',{style:'currency',currency:root.dataset.smouzCurrency||'EUR'}).format(cents*n/100):'—';
      if(total.textContent!==amount)total.textContent=amount;
      const caption=valid?String(n):'…';if(length.textContent!==caption)length.textContent=caption;
    }
    function queue(){if(!pending){pending=true;requestAnimationFrame(update)}}
    root.addEventListener('input',queue);
    root.addEventListener('change',queue);
    root.addEventListener('click',queue);
    root.addEventListener('submit',event=>{
      if(!event.target.matches('.f8pr-buy-button'))return;
      const input=event.target.querySelector('input[name="quantity"]');
      if(input&&!input.checkValidity()){event.preventDefault();event.stopImmediatePropagation();input.reportValidity()}
    },true);
    const observer=new MutationObserver(queue);
    observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['value','data-smouz-price','min','max']});
    root._smouzCleanup=()=>observer.disconnect();
    update();
  }
  function init(){document.querySelectorAll('.smouz-product-v8').forEach(initialize)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('.smouz-product-v8').forEach(r=>{if(r._smouzCleanup)r._smouzCleanup()}));
})();
